import { ASSET_GROUP_TYPE } from '@app/shared/enum/asset-group';

export const ASSET_GROUP_ICONS = {
    [ASSET_GROUP_TYPE.BUILDING]: 'business',
    [ASSET_GROUP_TYPE.SITE]: 'location_on',
    [ASSET_GROUP_TYPE.COMPANY]: 'business_center',
    [ASSET_GROUP_TYPE.DEPARTMENT]: 'location_city',
    [ASSET_GROUP_TYPE.GROUP]: 'group',
    [ASSET_GROUP_TYPE.ROOM]: 'meeting_room',
};
